// extracted by mini-css-extract-plugin
module.exports = {"buttons":"demo-buttons_buttons__ZIL6h","notice":"demo-buttons_notice__BLQkZ"};